<div fxFlex="auto" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px" class="maintenance-wrp" [ngClass]="networkClass">'
	<div class="logo-wrp-sm">
		<a routerLink="/">
			<img [ngClass]="order?.network" [src]="shop?.networkLogo" [alt]="shop?.networkName">
		</a>
	</div>
	<div class="postcode-page-content-wrp p-32x">
		<div class="postcode-page-inner-wrp" fxFlex="100" fxLayout="column" fxLayout.lt-md="column" fxLayoutAlign="center stretch"
			 fxLayoutAlign.lt-md="start center">
			<div fxFlex="none" fxLayout="column" fxLayoutAlign="center stretch">
				<p class="post-title dark tc">
					We are currently down for some essential maintenance and hope to be back up very soon!
				</p>
				<p class="post-sub-title dark tc">
					Please visit our <a [href]="mainWebsiteLink" class="main-site-link blue"><b>website</b></a> for further information on our locations and services
				</p>
			</div>
		</div>
	</div>

</div>